import { AppBar, Button, Grid, Link, Typography } from "@material-ui/core";
import ColoredDivider from "views/ColoredDivider/ColoredDivider";
import React from "react";

export default function FooterVideoPlace() {
  return (
    <div>
      <AppBar color="primary" position="relative" style={{ marginTop: "40px" }}>
        <Grid container alignItems="flex-start" justifyContent="flex-start">
          <Grid item xs={12}>
            <ColoredDivider />
          </Grid>

          <Grid item xs={12} style={{ marginTop: "20px" }}>
            <Grid
              container
              alignItems="flex-start"
              justifyContent="flex-start"
              style={{ textAlign: "center" }}
            >
              <Grid item xs={6} sm={3} style={{ textAlign: "center" }}>
                <Typography variant="body1">Navegação:</Typography>
                <br />
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Eletrônicos</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Móveis</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Imóveis</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Eletrônicos</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Móveis</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Imóveis</Typography>
                </Link>
              </Grid>

              <Grid item xs={6} sm={3} style={{ textAlign: "center" }}>
                <br />
                <br />
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Eletrônicos</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Móveis</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Imóveis</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Eletrônicos</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Móveis</Typography>
                </Link>
                <Link
                  href="/"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="body2">Imóveis</Typography>
                </Link>
              </Grid>
              <Grid item xs={12} sm={6} style={{ textAlign: "" }}>
                <Typography variant="body1">Contato:</Typography>
                <br />
                <Typography variant="subtitle1">(11) 2548-4729</Typography>
                <Typography variant="subtitle1">(11) 91030-0818</Typography>
                <Typography variant="body2">
                  comercial@redeloop.com.br
                </Typography>
                <Typography variant="caption">
                  Rua Pedroso Alvarenga, 691 10° Andar – Itaim Bibi – São Paulo
                  – SP – CEP 04531-011
                </Typography>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                textAlign: "center",
                paddingTop: "15px",
                paddingBottom: "15px",
              }}
            >
              <Typography variant="body1" color="secondary">
                © Copyright 2021 – LoopTV – Todos os direitos reservados.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
    </div>
  );
}
